import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import List from "Components/List/List";
import FlexRow from "Components/FlexRow";
import DotsIcon from "Assets/SVG/DotsIcon";
import React from "react";
import Space from "../../Components/Space";
import {ShopifyOrderIntegrationDto} from "../../Apis/Models/ShopifyOrderIntegrationDto";

interface IProps {
    data?: ShopifyOrderIntegrationDto[];
    isLoading: boolean;
}
const ShopifyOrderIntegrationsList = (props: IProps) => {
    
    const { t } = useTranslation();
    
    const { data, isLoading } = props;

    const navigate = useNavigate();
    
    return (
        <List<ShopifyOrderIntegrationDto> data={data} loading={isLoading} columns={[
            {
                title: t('websiteUrl'),
                textRender: (record) => record.websiteUrl
            },
            {
                title: t('settlementActive'),
                textRender: (record) => record.settlementActive ? t('yes') : t('no')
            },
            {
                title: t('productionImportActive'),
                textRender: (record) => record.productionImportActive ? t('yes') : t('no')
            },
            {
                title: t('version'),
                textRender: (record) => record.versionApplied?.toString()
            },
            {
                title: t('functions'),
                size: "min-content",
                customRender: (record) =>
                    (
                        <Space direction={"horizontal"} size={"large"}>
                            <FlexRow className={"h-100 clickable"} justify={"center"} onClick={() => navigate(`/settlements/shopifyOrderIntegrations/edit/${record.id}`)} >
                                <DotsIcon />
                            </FlexRow>
                        </Space>
                    )
            }
        ]} keyExtractor={(record) => record.id.toString()} />
    )
}

export default ShopifyOrderIntegrationsList
